import { Pipe, PipeTransform } from '@angular/core';
import { NgbDate } from '@ng-bootstrap/ng-bootstrap';
import { Util } from '@libs/utilities/util';


@Pipe({
    name: 'ngDatePipe',
    standalone: false
})
export class NgDatePipe implements PipeTransform {

	transform(date: Date): NgbDate {

		//0 - was any date defined?
		if (!date) return null!;

		//1 - format the date to the ngb format
		return Util.Date.toNgbDate(date) as NgbDate;
	}
}
